module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/2023/area-icon5-8020d4d507812ab6cd3c3e0e0e8e77d8.svg&quot;;"